import React, { useEffect } from 'react';
import ApexCharts from 'apexcharts';
import { chartOptions } from '../consts';

export function WishlistGraph({ data }) {
	const id = 'wishlist-graph';

	useEffect(() => {
		const element = document.getElementById(id);

		if (!element) {
			return;
		}
		const options = getChartOption(data);
		const chart = new ApexCharts(element, options);
		chart.render();

		return function cleanUp() {
			chart.destroy();
		};
	}, [data]);

	return <div id={id}></div>;
}

function getChartOption(data) {
	const dates = data?.result || [];
	const options = {
		series: [
			{
				name: 'Wishlist',
				data: dates.map((d) => d.wishlist),
			},
		],
		colors: ['#FE6F5E'],
		...chartOptions(dates),
	};
	return options;
}
